import Axios from "axios";

import { IDepositRemovalReason, IPaginatedResponse, IRefundReason } from "@utils";

interface IDeposit {
  id?: number;
  asset_family: string;
  amount: number;
  refunded: boolean;
  bidder_user: number;
  auction: number;
}

export async function getDeposits() {
  const response = await Axios.get("/api/deposits");
  return response.data;
}

export async function createDeposits(data: IDeposit[]) {
  const response = await Axios.post("/api/deposits/", data);
  return response.data;
}

export async function updateDeposits(data: IDeposit) {
  const id = data.id;
  const dataToSend = {
    asset_family: data.asset_family,
    amount: data.amount,
    refunded: data.refunded,
    bidder_user: data.bidder_user,
    auction: data.auction,
  };
  const response = await Axios.patch(`/api/deposits/${id}/`, dataToSend);
  return response.data;
}

export async function getRemovalReasons(): Promise<IDepositRemovalReason[]> {
  const reasons: IDepositRemovalReason[] = [];
  let url: string | null = "/api/deposits/removal-reasons/";
  while (url) {
    const response: { data: IPaginatedResponse<IDepositRemovalReason> } = await Axios.get(url);
    reasons.push(...response.data.results);
    url = response.data.next;
  }
  return reasons;
}

export interface IRemoveDepositPayload {
  reason: number;
  notes?: string;
}

export async function removeDeposit(id: number, payload: IRemoveDepositPayload) {
  await Axios.post(`/api/deposits/${id}/remove/`, payload);
}

export async function getRefundReasons(): Promise<IRefundReason[]> {
  const response = await Axios.get<IRefundReason[]>("/api/deposits/refund-reasons/");
  return response.data;
}

export interface IRefundDepositPayload {
  reason: number;
  notes?: string;
}

export async function refundDeposit(id: number, payload: IRefundDepositPayload) {
  await Axios.post(`/api/deposits/${id}/refund/`, payload);
}

interface IParkJVResponse {
  document_number: string;
}
export function parkJV(
  id: string,
  typology: string,
  customer: string,
  glaccount: string,
): Promise<IParkJVResponse> {
  return Axios.post<IParkJVResponse>(`/api/deposits/auction/${id}/park-jv/${typology}/`, {
    customer,
    ...(glaccount && { glaccount }),
  })
    .then((res) => res.data) // ✅ resolve with data
    .catch((err) => {
      console.log("Park JV error", err);

      const msg = err.response?.data?.errors?.map((e: { detail: string }) => e.detail).join("; ");
      return Promise.reject(msg ?? err);
    });
}
